import React, { useState } from 'react'
import { toast } from 'react-toastify';
import { formatDate } from '../../utils/dateUtils';

const NoDeliveryFeeRow = ({order, handleSave}) => {
  const {orderDate, url, CustomerProfile, smileNameInput, trackingJp} = order
  const [isUpdated, setIsUpdated] = useState(false);
  const [deliveryFee, setDeliveryFee] = useState(order.deliveryFeeJp || '');

const handleDeliveryFeeChange = (e) => {
  const value = e.target.value;
  // Check if the input value is numeric or empty (to allow clearing the input)
  if (!value || /^\d+$/.test(value)) {
    setDeliveryFee(value);
  }
};

  const handleUpdateClick = () => {
    if(deliveryFee){
      const updatedOrder = {
        ...order,
        deliveryFeeJp: deliveryFee,  // updated tracking value
      };
      handleSave(updatedOrder);
      console.log(updatedOrder)
      setIsUpdated(true)
    }else{
      toast.warning("Please input first!!")
    }
  };

  return (
    <tr className={`border-t border-gray-200 ${isUpdated ? 'bg-green-200' : ''}`}>
      <td className='p-4'>{CustomerProfile.contact}</td>
      <td className='p-4'>{smileNameInput}</td>
      <td className='p-4'>{formatDate(orderDate)}</td>
      <td className='p-4'>
        <a href={url} className="text-blue-500 hover:underline truncate w-80 block" target="_blank" rel="noopener noreferrer">
          {url}
        </a>
      </td>
      <td className='p-4'>{trackingJp}</td>
      <td className='p-4'><input 
          type="text" 
          placeholder="ค่่าส่งในญี่ปุ่น"
          value={deliveryFee}
          onChange={handleDeliveryFeeChange} 
          className="border-2 border-gray-300 p-2 rounded w-full focus:outline-none focus:border-blue-400"
        /></td>
      <td className='p-4'>
        <button 
          className='px-4 py-2 text-sm bg-blue-500 hover:bg-blue-600 text-white rounded'
          onClick={handleUpdateClick}
        >
          Update
        </button>
      </td>
    </tr>
  )
}

export default NoDeliveryFeeRow